import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import {
  FacebookButton,
  GoogleButton
} from '@dtx-company/shared-components/src/components/atoms/Button/index'
import { GENERATOR_GOOGLE_SSO_REDIS } from '@dtx-company/true-common/src/constants/featureFlags'
import { LayoutProps, SpaceProps } from 'styled-system'
import { SocialAuthProps } from './index.types'
import { SocialProvider } from '@dtx-company/true-common/src/types/socialProvider'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { Wrapper } from './styles'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'
import { useGoogleLoginUrl } from '@app/common/src/hooks/useGoogleLoginUrl'
import { useSocialAuthState } from '@dtx-company/inter-app/src/components/singleSignOn/social-auth/index.hooks'
import React from 'react'

export const SocialAuth: React.FC<SocialAuthProps & SpaceProps & LayoutProps> = ({
  onClick,
  onClickWhenDisabled,
  cta,
  disabled = false,
  onClickFacebookBtn,
  onClickGoogleBtn,
  isSignup,
  showFacebookBtn = false,
  ...rest
}) => {
  const { handleClick } = useSocialAuthState({ onClick })
  const { url: googleLoginUrl } = useGoogleLoginUrl(isSignup ? 'signup' : 'login')
  const showFBButton = !isSignup && showFacebookBtn
  const [cacheFormValues] = useFlowFeature(GENERATOR_GOOGLE_SSO_REDIS)
  const fullPageRedirectToGoogle = cacheFormValues

  return (
    <Wrapper {...rest} position="relative">
      {googleLoginUrl && (
        <>
          <a
            href={disabled || fullPageRedirectToGoogle ? undefined : googleLoginUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <GoogleButton
              disabled={disabled}
              type="button"
              height="38px"
              width="100%"
              onClick={async () => {
                await onClickGoogleBtn?.(googleLoginUrl)
                handleClick(SocialProvider.GOOGLE)
              }}
            >
              <Text variant="body/small" fontWeight={600} color="primary.black">
                {cta} Google
              </Text>
            </GoogleButton>
          </a>
        </>
      )}

      {showFBButton && (
        <FacebookButton
          disabled={disabled}
          type="button"
          height="38px"
          width="100%"
          onClick={() => {
            onClickFacebookBtn?.()
            handleClick(SocialProvider.FACEBOOK)
          }}
        >
          <Text variant="body/small" fontWeight={600} color="primary.black">
            {cta} Facebook
          </Text>
        </FacebookButton>
      )}
      <Box
        display={disabled ? 'flex' : 'none'}
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        onClick={(e: MouseEvent): void => {
          if (disabled && onClickWhenDisabled) {
            onClickWhenDisabled(e)
          }
        }}
      ></Box>
    </Wrapper>
  )
}
